import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HubioLoginComponent, HubioLoginCallbackComponent } from '@hubio/hubio-login';
import { ErrorNotFoundComponent } from '@core/components/error-not-found/error-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/communic8',
    pathMatch: 'full'
  },
  {
    path: 'config-manager',
    loadChildren: () => import('./modules/config-manager/config-manager-routing.module').then(m => m.ConfigManagerRoutingModule)
  },
  {
    path: 'communic8',
    loadChildren: () => import('./modules/communic8-download/communic8-download-routing.module').then(m => m.Communic8DownloadRoutingModule) 
  },
  {
    path: 'login',
    component: HubioLoginComponent
  },
  {
    path: 'login/callback',
    component: HubioLoginCallbackComponent,
  },
  {
    path: '**',
    component: ErrorNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
